import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Link } from "react-router-dom";

export default function Clients() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/leads", { params: { limit: 500 } }).then(r => {
    // dedupe by client_id
    const map = new Map();
    r.data.forEach(l => { if (!map.has(l.client_id)) map.set(l.client_id, l); });
    setItems([...map.values()]);
  }); }, []);
  const filtered = items.filter(x => !q || x.client_name.toLowerCase().includes(q.toLowerCase()) || (x.mobile || "").includes(q));
  return (
    <div className="space-y-6 animate-in">
      <div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Master</div>
        <h1 className="font-serif-display text-3xl">Clients</h1>
      </div>
      <Card className="p-4">
        <Input placeholder="Search by name or mobile" value={q} onChange={e => setQ(e.target.value)} data-testid="clients-search"/>
      </Card>
      <Card className="overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/50 text-[11px] uppercase tracking-wider text-muted-foreground">
            <tr><th className="text-left px-4 py-3">Client Code</th><th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3">Mobile</th><th className="text-left px-4 py-3">City</th></tr>
          </thead>
          <tbody>
            {filtered.map(c => (
              <tr key={c.client_id} className="border-t border-border hover:bg-accent/5">
                <td className="px-4 py-3 font-mono text-xs"><Link to={`/clients/${c.client_id}`} className="text-accent hover:underline">{c.client_code}</Link></td>
                <td className="px-4 py-3">{c.client_name}</td>
                <td className="px-4 py-3 font-mono text-xs">{c.mobile}</td>
                <td className="px-4 py-3">{c.city}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
